import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';
import { CloseIcon } from 'src/assets/icons/OldCloseIcon';
import { ChevronDownIcon } from 'src/assets/icons/ChevronDownIcon';
import { CheckIcon } from 'src/assets/icons/CheckIcon';
import { easeTransform } from 'src/domains/layouts/shared/animation/AnimationAndTransition.style';

interface ViewTypeProp {
    viewType?: 'default' | 'small';
}

export const CloseIconWrapper = styled(CloseIcon, { label: 'CloseIconWrapper' })`
    fill: #666666;
    align-self: start;
    cursor: pointer;
    margin-bottom: -3px;
    outline: none;
    width: 14px;
`;

export const ChevronDownWrapper = styled(ChevronDownIcon, { label: 'ChevronDownWrapper' })`
    fill: ${mainColors.main.primary};
    margin: 13px 8px;
    position: absolute;
    pointer-events: none;
    right: 5px;
    top: 0;
`;

export const SelectWrapper = styled('label', { label: 'SelectWrapper' }) <ViewTypeProp>`
    display: flex;
    flex-direction: column;
    position: relative;
`;


export const Values = styled('div', { label: 'Values' }) <ViewTypeProp>`
    align-items: center;
    box-sizing: border-box;
    background-color: ${mainColors.default.light};
    display: flex;

    ${({ viewType = 'default' }): string | undefined => {
        if (viewType === 'default') {
            return `
            border: solid 1px ${mainColors.grays.gray400};
            font-size: 18px;
            height: 40px;
            padding: 0 0 0 5px;
            `;
        } else if (viewType === 'small') {
            return `
                appearance: none;
                border: solid 1px ${mainColors.grays.gray400};
                height: 32px;
                align-items: center;
                padding: 8px 30px 8px 8px;
                opacity: 0.64;
                overflow: hidden;
                text-overflow: ellipsis;
                text-align: left;
                white-space: nowrap;
            `;
        }
    }}
`;

export const Value = styled('div', { label: 'Value' }) <ViewTypeProp>`
    border-radius: 4px;

    ${({ viewType = 'default' }): string | undefined => {
        if (viewType === 'default') {
            return `
                background-color: #dddddd;
                font-size: 13px;
                margin: 5px;
                padding: 5px;
            `;
        } else if (viewType === 'small') {
            return `
                font-size: 12px;
                flex: 0 0 auto;
                margin-right: 5px;
            `;
        }
    }}
`;
interface OptionsProp extends ViewTypeProp {
    hidden: boolean
}
export const Options = styled('div', { label: 'Options' }) <OptionsProp>`
    display: ${({ hidden }): string => hidden ? 'none' : 'block'};
    position: absolute;
    left: 0;
    width: 100%;
    z-index: 100;
    background: ${mainColors.default.light};

    ${({ viewType = 'default' }): string | undefined => {
        if (viewType === 'default') {
            return `
            border: 1px solid #ddd;
            top: 40px;
            height: 200px;
            `;
        } else if (viewType === 'small') {
            return `
            border: 1px solid ${mainColors.grays.gray200};
            top: 33px;
            `;
        }
    }}
`;
interface OptionProp extends ViewTypeProp {
    isSelected: boolean
}
export const Option = styled('div', { label: 'Option' }) <OptionProp>`
    width: 100%;
    color: #666666;
    cursor: pointer;

    ${({ viewType = 'default', isSelected }): string | undefined => {

        if (viewType === 'default') {
            return `
                background: ${isSelected ? '#ddd' : '#fff'};
                color: #666666;
                font-size: 18px;
                padding: 10px;
            `;
        } else if (viewType === 'small') {
            return `
                justify-content: space-between;
                color: ${mainColors.main.primary};
                display: flex;
                font-size: 12px;
                height: 32px;
                line-height: 1.33;
                padding: 9px;
        `;
        }
    }}
`;

export const SelectElement = styled('select', { label: 'SelectElement' }) <ViewTypeProp>`
    line-height: 30px;
    height: 32px;
    font-size: 14px;
    color: ${mainColors.default.dark};
    border: 1px solid ${mainColors.grays.gray200};
    box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.5);
    background-color: transparent;
`;

export const SelectError = styled('div', { label: 'SelectError' }) <ViewTypeProp>`
    flex: 1 0 100%;
    font-size: 12px;
    color: ${mainColors.status.error};
`;

interface StyledCheckboxProps {
    isChecked: boolean
}


export const CheckIconWrapper = styled(CheckIcon, { label: 'CheckIconWrapper' }) <StyledCheckboxProps>`
    position: absolute;
    width: 10px;
    fill: ${mainColors.default.light};
    transform: ${props => props.isChecked ? 'scale(1)' : 'scale(0)'};
    transition: ${easeTransform};
`;

export const CheckboxWrapper = styled('span', { label: 'CheckboxWrapper' }) <StyledCheckboxProps>`
    position: relative;
    align-items: center;
    display: flex;
    justify-content: center;
    flex: 0 0 16px;
    width: 16px;
    height: 16px;
    transition: background-color .2s ease;
    ${(props): string => buildCheckboxType(props.isChecked)};
    border-radius: 4px;
`;

export const buildCheckboxType = (isChecked: boolean): string => {
    if (isChecked) {
        return `
            background: ${mainColors.main.secondary};
        `;
    }
    return `
        border: solid 2px ${mainColors.main.secondary};
        background: none;
    `;
};
